import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import DriversAddMain from '../../components/drivers/DriversAddMain'

export default function DriverAddPage() {
  return (
   <>
   <TitleBar/>
   <NavMenu/>
   <DriversAddMain/>
   </>
  )
}
